import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-inactivity-warning-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if(isVisible){
    <div class="modal-overlay">
      <div class="modal-container">
        <div class="modal-header">
          <h2>Advertencia de sesión</h2>
        </div>
        <div class="modal-body">
          <p>
            Su sesión expirará en {{ remainingSeconds }} segundos debido a
            inactividad.
          </p>
          <p>¿Desea continuar con la sesión?</p>
        </div>
        <div class="modal-footer">
          <button class="btn-primary" (click)="continueSession()">
            Continuar sesión
          </button>
          <button class="btn-secondary" (click)="logout()">
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>

    }
  `,
  styles: [
    `
      .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
      }

      .modal-container {
        background-color: white;
        border-radius: 8px;
        width: 400px;
        max-width: 90%;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        overflow: hidden;
      }

      .modal-header {
        padding: 15px;
        background-color: #f8f9fa;
        border-bottom: 1px solid #e9ecef;
      }

      .modal-header h2 {
        margin: 0;
        font-size: 1.25rem;
        color: #212529;
      }

      .modal-body {
        padding: 20px;
        color: #495057;
      }

      .modal-footer {
        padding: 15px;
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        border-top: 1px solid #e9ecef;
      }

      button {
        padding: 8px 16px;
        border-radius: 4px;
        font-weight: 500;
        cursor: pointer;
        border: none;
      }

      .btn-primary {
        background-color: #0d6efd;
        color: white;
      }

      .btn-secondary {
        background-color: #6c757d;
        color: white;
      }
    `,
  ],
})
export class InactivityWarningModalComponent {
  @Input() isVisible = false;
  @Input() remainingSeconds = 30;

  @Output() continue = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  continueSession(): void {
    this.isVisible = false;
    this.continue.emit();
  }

  logout(): void {
    this.close.emit();
  }
}
